import React from "react";
import "react-toastify/dist/ReactToastify.min.css";
import { Icon } from "assets/Icon";
import { cn } from "utils/helpers";

export const CustomToastV2 = ({ success, closeToast, title, subtitle }) => (
	<div
		className={cn(
			"z-50 flex h-max justify-between gap-3 !rounded-md !border-2 bg-white p-4 pl-2 text-white shadow-md",
			success ? "!border-blue-600" : "!border-red-600",
			success ? "bg-blue-700" : "bg-red-600"
		)}
	>
		<div className="flex gap-3">
			<Icon
				icon={success === true ? "toast-success" : "toast-error"}
				className="-mt-2"
				iconClassName="text-white"
			/>
			<div>
				<div className={cn("font-roboto text-lg font-semibold")}>
					{title || (success ? "Success" : "Error")}
				</div>
				{subtitle && (
					<div className="font-roboto text-sm font-normal">{subtitle}</div>
				)}
			</div>
		</div>

		<div>
			<Icon
				icon="toast-close"
				// iconClassName={success ? "text-royal-blue" : "text-red-600"}
				className="cursor-pointer"
				onClick={closeToast}
				data-testid="toast-close-button"
			/>
		</div>
	</div>
);
